import { render, staticRenderFns } from "./add-video.vue?vue&type=template&id=62718b54&scoped=true&"
import script from "./add-video.vue?vue&type=script&lang=js&"
export * from "./add-video.vue?vue&type=script&lang=js&"
import style0 from "./add-video.vue?vue&type=style&index=0&id=62718b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62718b54",
  null
  
)

export default component.exports